import { waypointInit } from 'helpers/utils';

const waypointConfig = {
    selector: '.hero',
    funcs: [
        { target: 'waypoint--bottom' },
        {
            child: '.stats',
            target: 'waypoint--bottom',
        },
    ],
    offset: '80%',
};

function init() {
    waypointInit(waypointConfig);
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/hero.js